import { Fragment } from "react";

export default function CorrectionEmptyResults(props) {
    const { correctAnswer } = props;

    return (
        correctAnswer.map((line, index) => {
            return (
                <Fragment key={index}>
                    {line} <br />
                </Fragment>
            )
        })          
    )
}